/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './menu.props';
export {registerProps as ɵc} from './nav/nav-item/nav-item.props';
export {registerProps as ɵa} from './nav/nav.props';